import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
type SectionInserterProps = {
  after: string;
  onInsert: () => void;
};

/**
 * Grows on hover or focus so the pill doesn't cover the cards. Hidden on touch screens, where the
 * invisible target would open the catalog on a stray tap between cards.
 */
const SectionInserter = t0 => {
  const $ = _c(16);
  const {
    after,
    onInsert
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="absolute inset-x-0 -top-3 h-3" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span aria-hidden={true} className="h-px flex-1 bg-gradient-to-r from-transparent to-(--border-color-tertiary) to-40%" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== after || $[4] !== t) {
    t4 = t(_temp, {
      title: after
    });
    $[3] = after;
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoPlusSmall16 color="primary" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp2);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onInsert || $[10] !== t4 || $[11] !== t6) {
    t7 = <button aria-label={t4} className="flex cursor-pointer items-center gap-0.5 rounded-full border border-tertiary bg-primary py-0.5 pr-2.5 pl-1.5 text-caption-1 text-primary transition-colors hover:bg-hover-control" onClick={onInsert} type="button">{t5}{t6}</button>;
    $[9] = onInsert;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span aria-hidden={true} className="h-px flex-1 bg-gradient-to-l from-transparent to-(--border-color-tertiary) to-40%" />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = <div className="group/insert relative h-0 transition-[height] duration-150 ease-out focus-within:h-6.5 hover:h-6.5 pointer-coarse:hidden in-data-force-affordance:h-6.5">{t2}<div className="pointer-events-none absolute inset-x-0 -top-1 flex h-5.5 items-center gap-2 opacity-0 transition-opacity duration-150 group-focus-within/insert:pointer-events-auto group-focus-within/insert:opacity-100 group-hover/insert:pointer-events-auto group-hover/insert:opacity-100 in-data-force-affordance:opacity-100">{t3}{t7}{t8}</div></div>;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default SectionInserter;
function _temp($) {
  return $.insertSection;
}
function _temp2($_0) {
  return $_0.addSection;
}